var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1ModeratelySatisfied(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.16 31.88a4 4 0 11-8 0 4 4 0 018 0zm15.69-4a4 4 0 101.524.302 4 4 0 00-1.534-.302h.01zm3.16 21a2 2 0 00-2-2H27a2 2 0 000 4h22a2.001 2.001 0 002-2.02l.01.02zM67 38a29 29 0 10-58 0 29 29 0 0058 0zm-4 0a25 25 0 11-50.001 0A25 25 0 0163 38zm4 0a29 29 0 10-58 0 29 29 0 0058 0zm-4 0a25 25 0 11-50.001 0A25 25 0 0163 38z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Moderately_Satisfied.b4b01a62.svg";
export { SvgK1ModeratelySatisfied as ReactComponent };